"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fp = require("lodash/fp");

var _reactOutsideClickHandler = _interopRequireDefault(require("react-outside-click-handler"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var _SelectButton = _interopRequireDefault(require("../../SelectInput/SelectButton"));

var _SelectInput = require("../../SelectInput");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Filter = function Filter(props) {
  var filters = props.filters,
      selectedKeys = props.selectedKeys,
      setSelectedKeys = props.setSelectedKeys,
      searchHidden = props.searchHidden,
      headerControls = props.headerControls;
  var filterOptions = (0, _fp.orderBy)('label', 'asc', filters);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  var onChange = function onChange(value) {
    setSelectedKeys(value);
    setOpened(false);
  };

  var content = /*#__PURE__*/_react.default.createElement(_SelectInput.MultiSelectMiniForm, {
    value: selectedKeys,
    options: filterOptions,
    searchHidden: searchHidden,
    onSelect: onChange,
    headerControls: headerControls
  });

  var onOutsideClick = function onOutsideClick(e) {
    if (!e.target.closest('.select__dropdown')) setOpened(false);
  };

  return /*#__PURE__*/_react.default.createElement(_reactOutsideClickHandler.default, {
    onOutsideClick: onOutsideClick,
    display: "inline-block"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: content,
    overlayClassName: "Table-filters row-filters",
    placement: "leftBottom",
    trigger: "click",
    visible: opened
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter select select__multi-mini"
  }, /*#__PURE__*/_react.default.createElement(_SelectButton.default, {
    className: opened ? 'opened' : '',
    onClick: function onClick() {
      return setOpened(function (bool) {
        return !bool;
      });
    },
    ariaControlName: "multiselectFilter-dropdown",
    boxed: true,
    mini: true
  }))));
};

Filter.propTypes = {
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  selectedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
  searchHidden: _propTypes.default.bool,
  setSelectedKeys: _propTypes.default.func,
  headerControls: _propTypes.default.shape({
    selectControlsLabel: _propTypes.default.shape({
      selectAll: _propTypes.default.string,
      reset: _propTypes.default.string
    }),
    sortByLabel: _propTypes.default.string
  }).isRequired
};
Filter.defaultProps = {
  filters: [],
  selectedKeys: [],
  searchHidden: false,
  setSelectedKeys: function setSelectedKeys() {}
};
var _default = Filter;
exports.default = _default;